import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Grid,
  Card,
  CardContent,
  alpha,
} from '@mui/material';
import {
  People,
  Map,
  Chat,
  Build,
} from '@mui/icons-material';
import BaseTab from './BaseTab';

interface FrontendOverviewTabProps {
  isDark: boolean;
  colors: any;
  discordFont: any;
  glassStyle: any;
  lokiGradient: string;
  goldColor: string;
  isMobile: boolean;
}

const FrontendOverviewTab: React.FC<FrontendOverviewTabProps> = (props) => {
  return (
    <BaseTab
      {...props}
      title="Frontend Overview & Vision"
      emoji="🎯"
    >
      <Typography variant="body1" color={props.colors.textPrimary} sx={{ mb: 2 }}>
        WFHCafe is a <strong>comprehensive social networking platform</strong> designed specifically for remote workers, freelancers, and digital nomads who work from cafés and seek meaningful real-world connections.
      </Typography>
      <Typography variant="body1" color={props.colors.textPrimary} sx={{ mb: 3 }}>
        It transforms cafés into vibrant micro-workspaces and community hubs, bridging the gap between remote work isolation and organic human networking.
      </Typography>
      
      <Paper sx={{ bgcolor: alpha(props.goldColor, 0.1), p: 2, borderRadius: 2, mb: 3 }}>
        <Typography variant="h6" sx={{ color: props.goldColor, mb: 1 }}>
          🎯 Vision & Mission
        </Typography>
        <Typography variant="body2" color={props.colors.textPrimary}>
          <strong>Remote work shouldn't mean working alone.</strong> WFHCafe empowers professionals to discover work-friendly cafés, connect with like-minded individuals, network organically, build communities, and collaborate without forced meetings.
        </Typography>
      </Paper>
      
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
          <Card sx={{ height: '100%', bgcolor: alpha(props.goldColor, 0.1) }}>
            <CardContent>
              <People sx={{ color: props.goldColor, mb: 1 }} />
              <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
                Real Connections
              </Typography>
              <Typography variant="body2" color={props.colors.textSecondary}>
                Meet professionals in your local cafés
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
          <Card sx={{ height: '100%', bgcolor: alpha('#0F3B2E', 0.1) }}>
            <CardContent>
              <Map sx={{ color: '#0F3B2E', mb: 1 }} />
              <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
                Real Places
              </Typography>
              <Typography variant="body2" color={props.colors.textSecondary}>
                Discover verified work-friendly cafés
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
          <Card sx={{ height: '100%', bgcolor: alpha('#1D5C4A', 0.1) }}>
            <CardContent>
              <Chat sx={{ color: '#1D5C4A', mb: 1 }} />
              <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
                Real Communities
              </Typography>
              <Typography variant="body2" color={props.colors.textSecondary}>
                Join local and interest-based groups
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
          <Card sx={{ height: '100%', bgcolor: alpha(props.colors.accent, 0.1) }}>
            <CardContent>
              <Build sx={{ color: props.colors.accent, mb: 1 }} />
              <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
                Built-in-Public
              </Typography>
              <Typography variant="body2" color={props.colors.textSecondary}>
                Actively developed with community feedback
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </BaseTab>
  );
};

export default FrontendOverviewTab;